import { render, staticRenderFns } from "./salaryrecord.vue?vue&type=template&id=4c15f3a1&scoped=true&"
import script from "./salaryrecord.vue?vue&type=script&lang=js&"
export * from "./salaryrecord.vue?vue&type=script&lang=js&"
import style0 from "./salaryrecord.vue?vue&type=style&index=0&id=4c15f3a1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c15f3a1",
  null
  
)

export default component.exports